import { TaskStatus } from '@exam-management/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

export function useMyTaskSearchParams() {
  // TODO: remove unused data grid params
  const [{ page, pageSize, field, sort, status }, setQueryState] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    field: parseAsString.withDefault('dueDate'),
    sort: parseAsStringLiteral(dataGridSortDirection).withDefault('asc'),
    status: parseAsStringEnum(Object.values(TaskStatus)).withDefault(TaskStatus.Todo),
  });

  const changeStatus = (value: TaskStatus) => {
    setQueryState({ status: value, page: 0 });
  };

  const changePage = (value: number) => {
    setQueryState({ page: value });
  };

  return [
    { page, pageSize, field, sort, status },
    // TODO: Remove unused setQueryState and changeStatus when new MyTaskList is implemented
    { setQueryState, changeStatus, changePage },
  ] as const;
}
